const labels = {
  en: {
    title_email: 'Customize your email signature!',
    title_avatar: 'Get your customized avatar!',
    topMentions: 'Get your own Publicis Sapient email signature in less than 1 minute.',
    buttonIntegrate: 'Integrate your signature',
    copiedClipboard: 'Copied in clipboard!',
    installation: 'Email signature integration',
    buttonCopySignature: 'Copy the signature',
    buttonBack: 'Back',
    titleFollowInstructions: 'Follow the steps',
    errorTitle: 'Oups',
    popinClose: 'Close',
    mail: {
      title: 'Customize your email signature!',
      object: 'My email signature',
      to: 'To:',
      recipient: 'ALL@publicissapient.com',
      courtesy: 'Hi everyone! Just a quick email to show you your brand new Publicis Sapient signature! Not bad huh? Try for yourself ;)',
      mobileLetter: 'M',
      phoneLetter: 'P',
      pronouns: 'Pronouns',
      donate_ukraine: `<a href="https://helping-our-ukraine-team-as-one.iraiser.eu/b/my-donation?cid=1&_cv=1" style="padding-top: 10px; color: #666666; text-decoration: none;font-size: 10px; font-family: arial, helvetica; text-decoration: underline; line-height: 14px;" target="_blank"
      aria-description="Donate Now to Publicis Groupe Fundraiser for Our Team in Ukraine.">
        Donate Now to Publicis Groupe Fundraiser <br />for Our Team in Ukraine.</a>`,
    },
    tabs: {
      email: 'Create your signature',
      avatar: 'Create your avatar',
    },
    form: {
      name: 'First Name',
      name_required: 'The name is required',
      lastname: 'Last Name',
      lastname_required: 'The last name is required',
      job: 'Title',
      job_required: 'The job title is required',
      pronouns: 'Pronouns (optional)',
      pronounsList: [
        'she/they',
        'he/they',
        'she/her/hers',
        'he/him/his',
        'they/them/theirs',
      ],
      pronounsPopin: {
        title: 'Include your pronouns:',
        text: 'Publicis Sapient represents a diverse set of gender identities and expressions. If you’d like to ensure you’re addressed by the correct pronouns, or demonstrate your support for gender inclusivity, add yours here. <br/><a target="_blank" href="https://marcel.ai/app/article/8f06fac0-3ff7-5304-ab0e-2e349e139ed3">Read why pronouns matter</a>',
      },
      pslogo: 'Logo',
      pslogoList: {
        PS_Brand: 'PS Brand',
        PS_Pride: 'PS Pride'
      },
      office: 'Office',
      office_required: 'The office is required',
      mobile: 'Mobile',
      phone: 'Phone',

      accolades: 'Select your Accolades (optional)',
      accoladesList: {
        consulting_reports_top_50_consulting_firms: '2024 Consulting Report\'s Top 50 Consulting Firms',
        forbes_worlds_best_management_consulting_firms: '2024 Forbes World\'s Best Management Consulting Firms',
        HFS_generative_enterprise_services_market_leader_2023: 'HFS Generative Enterprise Services Market Leader, 2023',
        idc_marketScape_for_worldwide_experience_design_2023_24: 'IDC MarketScape for Worldwide Experience Design, 2023-24',
        e_footprint: 'e-footprint',
        google_cloud_partner_of_the_year_2024: 'Google Cloud Partner of the Year 2024',
        VivaTech_2024: 'VivaTech 2024',
        disability_confident_employer: 'Disability Confident Employer',
        guide_to_next: 'Guide to Next',
        consulting_magazine_best_firms_to_work_for_2023: ' Consulting Magazine Best Firms to Work For 2023',
        Consultancy_uk_Top_Consulting_Firms_in_UK_2023: 'Consultancy.uk - Top Consulting Firms in UK 2023',
        consulting_report_top_consulting_firm_2023: 'Consulting Report – Top Consulting Firm 2023',
        carbon_markets: 'Carbon Markets',
        get_ahead_cp: 'Get Ahead - CP',
        seize_the_space_t_h: 'Seize the Space - T&H',
        vault_emea: 'Vault Best Consulting Firms – EMEA',
        vault_north_america: 'Vault Best Consulting Firms – North America',
        vault_apac: 'Vault Best Consulting Firms – APAC',
        workingwithcancer: '#workingwithcancer',
        great_place_to_work_germany: 'Great Place to Work - Germany',
        great_place_to_work_us: 'Great Place to Work - US',
        iDBT: 'iDBT',
        consulting_magazine_best_firms: 'Consulting Magazine Best Firms',
        school_of_next: 'School of Next',
        forbes_best_consulting_firms: 'Forbes Best Consulting Firms',
        egalite: 'ÉGALITÉ',
        shopper_first_retail: 'Shopper First Retail',
        uk_financial_times: 'UK Financial Times',
        human_rights_campaign: 'Human Rights Campaign',
        energy_tech_awards: 'EnergyTech Awards',
        tech_women: 'We Are Tech Women',
        gptw_germany: 'Great Place to Work (Germany), 2019-20',
        certified_great_place: 'Great Place to Work (India), 2019-20',
        the_how_channel: 'The HOW Channel',
        enable: 'enABLE',
        gartner_peer_insights: 'Gartner Peer Insights',
        idc_marketscape_2: 'IDC MarketScape',
        gartner_topscorercx: 'Gartner Top Scorer',
        gartner_magic_quadrant: 'Gartner Magic Quadrant',
        vault_top_ranked_internship_program_2025: 'Vault Top Ranked Internship Program, 2025',
        vault_top_ranked_internship_program_lgbtq_2025: 'Vault Top Ranked Internship Program for LGBTQ+ Individuals, 2025',
        VivaTech_2025: 'VivaTech 2025',
        none: 'None'
      },
      mentions: 'Don’t worry, your personal data won’t be registered.',
      donate: `To support our colleagues in Ukraine add this message.`,
    },
    instructions: {
      title_outlook_mac: 'Outlook Mac',
      title_outlook_windows: 'Outlook Windows',
      title_webmail: 'Webmail',
      outlook_mac: `
      <p>1. Click on the <span>Copy the signature</span> button below</p>
      <p>2. In the menu bar, select <span>Outlook › Preferences</span> and then click on <span>Signatures</span></p>
      <p>3. Click on <span>[+]</span> and enter a name for your new signature</p>
      <p>4. Paste your signature (Cmd + V)<br>
      In Outlook 2016, make sure you select the <span>keep source formatting option</span> in the Paste Options menu</p>
      <p>5. Save then select your new signature in the <span>New messages</span> and <span>Replies/ forwards</span> dropdown menus</p>
      <img src="static/img/options-collage-en.jpg" alt="">
      `,
      outlook_windows: `
      <p>1. Click on the <span>Copy the signature</span> button below</p>
      <p>2a. For older outlook version: <span>Go to File › Options › Mail</span>. In the <span>Compose messages</span> section, click on <span>Signatures</span></p>
      <p>2b. For newer outlook version: <span>Go to File › Settings › Accounts > Signatures</span></p>
      <p>3. Click on <span>New</span> and enter a name for your new signature</p>
      <p>4. Paste your signature (Ctrl + V) in the <span>Edit signature field</span></p>
      <p>5. On right hand side, under <span>Choose default signature</span>, select your email account</p>
      <p>6. Select your new signature in the <span>New messages</span> and <span>Replies/forwards</span> dropdown menus</p>
      `,
      webmail: `
      <p>1. Click on the <span>Copy the signature</span> button below</p>
      <p>2. Click on the <span>Settings</span> icon on the top right hand corner to open the <span>Parameters</span> menu and type <span>"Email Signature"</span> in the search bar</p>
      <p>3. Paste your signature (Ctrl + V) in the <span>email signature field</span></p>
      <p>4. Check the <span>Automatically include my signature on messages I send</span> box</p>
      `,
    },
    avatar: {
      topMentions: 'Get your branded Publicis Sapient profile picture in a few clicks.',
      photo: {
        title: 'Step 1. Upload your profile picture',
        titleUploaded: 'Step 1. Avatar Review',
        upload: 'Upload a photo',
        select: 'Select a photo from your computer (accepted formats: JPG, PNG, GIF, Bitmap).',
        recommend: 'The recommended dimensions for your avatar image:',
        size: 'Minimum size of 200 pixels by 200 pixels.',
        adjust: 'You will be able to edit to adjust the image by enlarging or reducing the size.',
        change: 'Change Photo',
        zoomOut: 'Zoom out',
        zoomIn: 'Zoom in',
      },
      color: {
        title: 'Step 2. Chose your color circle',
        select: 'Choose a color',
      },
      review: {
        title: 'Step 3. Update your avatar',
        download: 'Download your avatar',
      },
      instructions: {
        title_vox: 'Vox',
        title_linkedin: 'LinkedIn',
        title_outlook_mac: 'Outlook (Mac)',
        title_outlook_windows: 'Outlook (Win)',
        title_outlook_webmail: 'Webmail',
        vox: `
          <p>1. Go to <a href="https://vox.publicis.sapient.com/news" target="blank">Vox</a></p>
          <p>2. Click on the <span>avatar</span> at the top right</p>
          <p>3. Click on <span>Edit profile</span></p>
          <p>4. Go to Avatar's part</p>
          <p>5. Click on <span>Add another avatar</span> › Choose your previously downloaded avatar › Upload and continue</p>
          <p>6. Click on <span>crop photo</span></p>
          <p>Your new avatar has been uploaded!</p>
        `,
        linkedin: `
          <p>1. Go to <a href="https://www.linkedin.com/feed/" target="blank">LinkedIn</a></p>
          <p>2. Go to your <span>profile</span></p>
          <p>3. Click on your <span>image</span></p>
          <p>4. Click on <span>Change photo / Upload photo</span></p>
          <p>5. Choose your avatar (that you previously downloaded below) "avatar_linkedin"</p>
          <p>6. Decrease the zoom to the minimum (1) then increase the zoom slider to 1.1. Your color circle will go beyond the LinkedIn display. (see image below)</p>
          <center><img src="static/img/capture_linkedin.jpg" alt=""></center>
          <p>7. Save</p>
        `,
        outlook_mac: `
          <p>1. Go to your <a href="https://outlook.office.com/" target="blank">webmail</a></p>
          <p>2. Click on your <span>avatar</span> at the top right</p>
          <p>3. Once on your profile, click on the <span>camera</span> near your image › <span>Upload a new image</span></p>
          <p>4. Choose your avatar (that you previously downloaded below)</p>
          <p>5. Replace your image</p>
          <p>6. Click on <span>Set as profile picture</span></p>
        `,
        outlook_windows: `
          <p>1. Go to <span>Outlook</span></p>
          <p>2. Click on <span>Files › Information › Account settings › Edit</span></p>
          <p>3. You are redirected to the webmail</p>
          <p>4. Click on <span>Upload a photo</span> and choose your avatar (that you previously downloaded below)</p>
          <p>5. Click on <span>Save</span></p>
          <p>Your avatar is now uploaded and will automatically be added to <span>Skype</span> and <span>Outlook</span></p>
        `,
        outlook_webmail: `
          <p>1. Go to your <a href="https://outlook.office.com/" target="blank">webmail</a></p>
          <p>2. Click on your <span>avatar</span> at the top right</p>
          <p>3. Once on your profile, click on the <span>camera</span> near your image › <span>Upload a new image</span></p>
          <p>4. Click on <span>Upload a photo</span> and choose your avatar (that you previously downloaded below)</p>
          <p>5. Click on <span>Save</span></p>
          <p>Your avatar is now uploaded and will automatically be added to <span>Skype</span> and <span>Outlook</span></p>
        `,
      },
    }
  },
  fr: {
    title_email: 'Personnalisez votre signature mail&nbsp;!',
    title_avatar: 'Obtenez votre avatar personnalisé&nbsp;!',
    topMentions: 'Obtenez votre signature mail aux couleurs de Publicis Sapient en moins d’une minute.',
    buttonIntegrate: 'Intégrer votre signature',
    copiedClipboard: 'C\'est copié !',
    installation: 'Intégration de votre signature',
    buttonCopySignature: 'Copier la signature',
    buttonBack: 'Retour',
    titleFollowInstructions: 'Suivez le pas à pas',
    errorTitle: 'Oups',
    popinClose: 'Fermer',
    mail: {
      title: 'Personnalisez votre signature mail !',
      object: 'Ma signature de mail',
      to: 'À :',
      recipient: 'ALL@publicissapient.com',
      courtesy: 'Hello l\’agence ! Ce petit mail pour vous montrer à quoi ressemblera votre nouvelle signature Publicis Sapient ! Pas mal, non ?\nÀ vous de jouer maintenant ;)',
      mobileLetter: 'M',
      phoneLetter: 'T',
      pronouns: 'Pronoms',
      donate_ukraine: `<a href="https://helping-our-ukraine-team-as-one.iraiser.eu/b/my-donation?cid=1&_cv=1" style="padding-top: 10px; color: #666666; text-decoration: none;font-size: 10px; font-family: arial, helvetica; text-decoration: underline;  line-height: 14px;"  target="_blank"
      aria-description="Contribuez à la levée de fonds du Groupe Publicis et venez en aide à notre équipe en Ukraine.">
      Contribuez à la levée de fonds du Groupe Publicis <br />et venez en aide à notre équipe en Ukraine.</a>`,
    },
    tabs: {
      email: 'Créer votre signature',
      avatar: 'Créer votre avatar',
    },
    form: {
      name: 'Prénom',
      name_required: 'Le prénom est requis',
      lastname: 'Nom',
      lastname_required: 'Le nom de famille est requis',
      job: 'Fonction',
      job_required: 'La fonction est requise',
      pronouns: 'Pronoms (optionnel)',
      pronounsList: [
        'Il',
        'Elle',
        'Iel',
        'Yel',
        'Ille',
        'El',
        'Ul',
        'Ol',
        'Yol',
        'Ael',
        'Im',
        'Em',
      ],
      pronounsPopin: {
        title: 'Inclure un pronom:',
        text: 'Publicis Sapient représente un ensemble diversifié d\'identités et d\'expressions de genre. Si vous souhaitez vous assurer que les pronoms sont corrects ou si vous manifestez votre soutien à l\'inclusion du genre, incluez le vôtre ici.',
      },
      pslogo: 'Logo',
      pslogoList: {
        PS_Brand: 'PS Brand',
        PS_Pride: 'PS Pride'
      },
      office: 'Locaux',
      office_required: 'Le bureau est requis',
      mobile: 'Portable',
      phone: 'Fixe',
      accolades: 'Choisissez des accolades (optionnel)',
      accoladesList: {
        consulting_reports_top_50_consulting_firms: '2024 Consulting Report\'s Top 50 Consulting Firms',
        forbes_worlds_best_management_consulting_firms: '2024 Forbes World\'s Best Management Consulting Firms',
        HFS_generative_enterprise_services_market_leader_2023: 'HFS Generative Enterprise Services Market Leader, 2023',
        idc_marketScape_for_worldwide_experience_design_2023_24: 'IDC MarketScape for Worldwide Experience Design, 2023-24',
        e_footprint: 'e-footprint',
        google_cloud_partner_of_the_year_2024: 'Google Cloud Partner of the Year 2024',
        VivaTech_2024: 'VivaTech 2024',
        business_disability_forum_member: 'Business Disability Forum Member',
        guide_to_next: 'Guide to Next',
        Consultancy_uk_Top_Consulting_Firms_in_UK_2023: 'Consultancy.uk - Top Consulting Firms in UK 2023',
        consulting_report_top_consulting_firm_2023: 'Consulting Report – Top Consulting Firm 2023',
        carbon_markets: 'Carbon Markets',
        get_ahead_cp: 'Get Ahead - CP',
        seize_the_space_t_h: 'Seize the Space - T&H',
        vault_emea: 'Vault Best Consulting Firms – EMEA',
        vault_north_america: 'Vault Best Consulting Firms – North America',
        vault_apac: 'Vault Best Consulting Firms – APAC',
        workingwithcancer: '#workingwithcancer',
        great_place_to_work_germany: 'Great Place to Work - Germany',
        great_place_to_work_us: 'Great Place to Work - US',
        iDBT: 'iDBT',
        consulting_magazine_best_firms: 'Consulting Magazine Best Firms',
        school_of_next: 'School of Next',
        forbes_best_consulting_firms: 'Forbes Best Consulting Firms',
        egalite: 'ÉGALITÉ',
        shopper_first_retail: 'Shopper First Retail',
        uk_financial_times: 'UK Financial Times',
        human_rights_campaign: 'Human Rights Campaign',
        energy_tech_awards: 'EnergyTech Awards',
        tech_women: 'We Are Tech Women',
        gptw_germany: 'Great Place to Work (Germany), 2019-20',
        certified_great_place: 'Great Place to Work (India), 2019-20',
        the_how_channel: 'The HOW Channel',
        enable: 'enABLE',
        gartner_peer_insights: 'Gartner Peer Insights',
        idc_marketscape_2: 'IDC MarketScape',
        gartner_topscorercx: 'Gartner Top Scorer',
        gartner_magic_quadrant: 'Gartner Magic Quadrant',
        vault_top_ranked_internship_program_2025: 'Vault Top Ranked Internship Program, 2025',
        vault_top_ranked_internship_program_lgbtq_2025: 'Vault Top Ranked Internship Program for LGBTQ+ Individuals, 2025',
        VivaTech_2025: 'VivaTech 2025',
        none: 'Aucune'
      },
      mentions: 'Pas d’inquiétude, vos données personnelles ne seront pas enregistrées.',
      donate: `Afin de venir en aide à nos collègues en Ukraine,<br />veuillez recopier ce message.`,
    },
    instructions: {
      title_outlook_mac: 'Outlook Mac',
      title_outlook_windows: 'Outlook Windows',
      title_webmail: 'Webmail',
      outlook_mac: `
      <p>1. Cliquez sur <span>Copier la signature</span> ci-dessous</p>
      <p>2. Dans la barre de menu, accédez à <span>Outlook › Préférences</span> puis cliquez sur <span>Signatures</span></p>
      <p>3. Cliquez sur le signe <span>[+]</span> et entrez un nom pour votre nouvelle signature</p>
      <p>4. Dans l'encadré <span>Principal</span>, collez la signature (Cmd + V)<br>
      Sur Outlook 2016, veillez à sélectionner la première option de collage <span>Conserver la mise en forme de la source</span></p>
      <p>5. <span>Enregistrez</span> puis sélectionnez la signature que vous venez de créer dans les 2 menus déroulants (<span>Nouveaux messages</span> et <span>Réponses/transferts</span>)</p>
      <img src="static/img/options-collage-fr.jpg">
      `,
      outlook_windows: `
      <p>1. Cliquez sur <span>Copier la signature</span> ci-dessous</p>
      <p>2a. Pour les anciennes versions d'Outlook : <span>Accédez à Fichier > Options > Courrier</span>. Dans la section <span>Rédiger un message</span>, cliquez sur <span>Signatures</span></p>
      <p>2b. Pour les versions plus récentes d'Outlook : <span>Accédez à Fichier > Paramètres > Comptes > Signatures</span></p>
      <p>3. Cliquez sur <span>Nouveau</span> et donnez un nom à votre nouvelle signature</p>
      <p>4. Dans l’encadré <span>Modifier la signature</span>, collez votre signature (Ctrl + V)</p>
      <p>5. Sur la droite, sous <span>Choisir une signature par défaut</span>, sélectionnez la signature que vous venez de créer</p>
      <p>6. Sélectionnez la signature que vous venez de créer dans les 2 menus déroulants (<span>Nouveaux messages</span> et <span>Réponses/transferts</span>)</p>
      `,
      webmail: `
      <p>1. Cliquez sur <span>Copier la signature</span> ci-dessous</p>
      <p>2. Ouvrez le menu <span>Paramètres</span> en cliquant sur l'icône en haut à droite et tapez <span>"Signature électronique"</span> dans la barre de recherche</p>
      <p>3. Collez la signature (Ctrl + V) dans l'encadré <span>Signature de message électronique</span></p>
      <p>4. Cochez <span>Ajouter automatiquement ma signature aux messages envoyés</span></p>
      `,
    },
    avatar: {
      topMentions: 'Créez en quelques clics votre photo de profil aux couleurs de Publicis Sapient.',
      photo: {
        title: 'Étape 1. Téléchargez votre photo',
        titleUploaded: 'Étape 1. Prévisualisation de l\'avatar',
        upload: 'Sélectionnez une photo',
        select: 'Sélectionnez une photo depuis votre ordinateur (formats acceptés : JPG, PNG, GIF, Bitmap)',
        recommend: 'Les dimensions recommandées pour votre image d\'avatar:',
        size: 'Taille minimale de 200 pixels par 200 pixels.',
        adjust: 'Vous pourrez éditer pour ajuster l\'image en agrandissant ou en réduisant la taille.',
        change: 'Changer la photo',
        zoomOut: 'Zoom arrière',
        zoomIn: 'Zoom avant',
      },
      color: {
        title: 'Étape 2. Choisissez la couleur de votre anneau',
        select: 'Sélectionnez une couleur',
      },
      review: {
        title: 'Étape 3. Mettez à jour votre avatar dans vos profils',
        download: 'Télécharger votre avatar',
      },
      instructions: {
        title_vox: 'Vox',
        title_linkedin: 'LinkedIn',
        title_outlook_mac: 'Outlook (Mac)',
        title_outlook_windows: 'Outlook (Win)',
        title_outlook_webmail: 'Webmail',
        vox: `
          <p>1. Rendez-vous sur <a href="https://vox.publicis.sapient.com/news" target="blank">Vox</a></p>
          <p>2. Cliquez sur votre <span>avatar</span> en haut à droite</p>
          <p>3. Cliquez sur <span>Modifier le profil</span></p>
          <p>4. Allez dans la partie Avatar</p>
          <p>5. Cliquez sur <span>Ajouter un nouvel avatar</span> › Choisissez votre avatar (que vous aurez téléchargé au préalable) › Téléchargez et continuez</p>
          <p>6. Cliquez sur <span>Recadrer la photo</span></p>
          <p>Ça y est, votre nouvel avatar est téléchargé !</p>
        `,
        linkedin: `
          <p>1. Rendez-vous sur <a href="https://www.linkedin.com/feed/" target="blank">LinkedIn</a></p>
          <p>2. Allez sur <span>votre profil</span></p>
          <p>3. Cliquez sur votre photo</p>
          <p>4. Cliquez sur <span>Modifier la photo / Upload photo</span></p>
          <p>5. Choisissez votre avatar (que vous aurez téléchargé au préalable) "avatar_linkedin"</p>
          <p>6. Diminuez le zoom au minimum (1) puis augmentez le curseur zoom à 1.1. Ainsi votre cercle de couleur dépassera de l'affichage LinkedIn. (voir image ci-dessous)</p>
          <center><img src="static/img/capture_linkedin.jpg" alt=""></center>
          <p>7. Enregistrez votre nouvelle image</p>
        `,
        outlook_mac: `
          <p>1. Rendez-vous sur votre <a href="https://outlook.office.com/" target="blank">webmail</a></p>
          <p>2. Cliquez sur votre <span>avatar</span> en haut à droite</p>
          <p>3. Une fois sur votre profil, cliquez sur l'<span>appareil photo</span> près de votre photo › <span>Chargez une nouvelle image</span></p>
          <p>4. Choisissez votre avatar (que vous aurez téléchargé au préalable)</p>
          <p>5. Recadrez votre nouvelle image</p>
          <p>6. Cliquez sur <span>Définir comme photo de profil</span></p>
        `,
        outlook_windows: `
          <p>1. Rendez-vous sur <span>Outlook</span></p>
          <p>2. Cliquez sur <span>Fichier › Informations › Paramètre du compte › Modifier</span></p>
          <p>3. Vous êtes redirigé sur le webmail</p>
          <p>4. Cliquez sur <span>Charger une photo</span> et choisissez votre avatar (que vous aurez téléchargé au préalable)</p>
          <p>5. Cliquez sur <span>Enregistrer</span></p>
          <p>Ça y est, votre nouvel avatar est téléchargé et se chargera automatiquement sur <span>Skype</span> et <span>Outlook</span> !</p>
        `,
        outlook_webmail: `
          <p>1. Rendez-vous sur votre <a href="https://outlook.office.com/" target="blank">webmail</a></p>
          <p>2. Cliquez sur votre <span>avatar</span> en haut à droite</p>
          <p>3. Une fois sur votre profil, cliquez sur l'<span>appareil photo</span> près de votre photo › <span>Chargez une nouvelle image</span></p>
          <p>4. Cliquez sur <span>Charger une photo</span> et choisissez votre avatar (que vous aurez téléchargé au préalable)</p>
          <p>5. Cliquez sur <span>Enregistrer</span></p>
          <p>Ça y est, votre nouvel avatar est téléchargé et se chargera automatiquement sur <span>Skype</span> et <span>Outlook</span> !</p>
        `,
      },
    }
  }
}



export default labels;



// WEBPACK FOOTER //
// ./src/labels/labels.js